<template>
 <div>账号注销中...</div>
</template>

<script type="text/javascript">

export default {
    components: {},
    props: {},
    data() {
        return {
            url: SZH.assets.api + '/Authen/Logout',
        }
    },
    methods: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        var self = this;
        self.$http.post(self.url, {
        }).then(result => {
            localStorage.removeItem('ms_customname');
            localStorage.removeItem('ms_accountname');
            localStorage.removeItem('ms_customno');
            localStorage.removeItem('ms_token');
            localStorage.removeItem('ms_token_expires');
            self.$router.push({ path: '/Login' })
        }, () => {
        });
    },
    watch: {}
}
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Logout/Logout.vue